import axios from "axios";
import React, { useState, useEffect, Link } from "react";
import { alert_error } from "../../AppContext";
import ToggleButton from "../../app_structure/toggleButton";
import { AiFillHeart } from "react-icons/ai";

import {
  auth,
  doc,
  where,
  query,
  collection,
  db,
  onSnapshot,
} from "../../js/firebase.js";
const Products = (props) => {

  const [storedata, setstoredata] = useState(null);
  const [product, setproduct] = useState(null);
  const { iduser } = props;
  function laysanphamtime() {
    const apidata = {
      username: "thoahv9000",
      chedo: "laythongtin",
      dulieu: "product",
      sapxep: "time",
    };
    const headers = {
      "Content-Type": "application/json",
    };
    axios
      .post("https://hust.media/api/account.php", apidata, headers)
      .then((response) => setproduct(response.data))
      .catch((error) => {
        alert_error(error);
      });
  }
  const laydulieustore = async () => {
    const iduserNumber = Number(iduser);
    if (iduserNumber) {
      const userRef = query(
        collection(db, "store"),
        where("iduser", "==", iduserNumber)
      );
      const unsubscribe = onSnapshot(userRef, (querySnapshot) => {
        if (!querySnapshot.empty) {
          const data = querySnapshot.docs.map((docSnapshot) => {
            const id = docSnapshot.id;
            const docData = docSnapshot.data();
            return { id, ...docData };
          });
          console.log(data);
          setstoredata(data);
          props.setstore_data(data);
        } else {
          console.log("No such document!");
        }
      });
    }

  };
  function laysanphamtrend() {
    const apidata = {
      username: "thoahv9000",
      chedo: "laythongtin",
      dulieu: "product",
      sapxep: "trend",
    };
    const headers = {
      "Content-Type": "application/json",
    };
    axios
      .post("https://hust.media/api/account.php", apidata, headers)
      .then((response) => setproduct(response.data))
      .catch((error) => {
        alert_error(error);
      });
  }
  function handleToggle(isOn) {
    if (isOn) {
      laysanphamtime();
    } else {
      laysanphamtrend();
    }
  }
  useEffect(() => {
    laydulieustore();
  }, []);
  return (
    <div className="form-control px-1 py-3 bg-slate-100 mt-0">
      Yêu thích <ToggleButton onToggle={handleToggle} isOnload="no" /> Mới nhất
      <div className="mt-3 grid grid-cols-2 gap-3 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5">
        {storedata &&
          storedata.map((item) => {
            return (
              <div className="col-span-1 border border-slate-400 pt-2 px-4 pb-2">
                <div className="flex py-2 items-start">
                  <img
                    src="https://subgiare.vn/sneat/assets/img/icons/unicons/bookmark.png"
                    alt="abc"
                    className="w-[40px] lg:w-[60px] object-contain flex-shrink-0"
                  />
                  <div className="flex-grow">
                    <div className="flex items-center">

                      <AiFillHeart />

                      <span className="text-black my-1 text-xs uppercase">
                        : {item.heart}
                      </span>
                    </div>

                    <h3 className="text-black my-1  text-xs uppercase">
                      id: {item.id}
                    </h3>
                  </div>
                </div>


                <div className="text-[6f6f6f]"> {item.caption}</div>
                <div className="text-[6f6f6f]">
                  Ngày mở gian hàng:{" "}
                  {item.createdate
                    ? new Date(
                      item.createdate.seconds * 1000
                    ).toLocaleDateString()
                    : ""}
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default Products;
